import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {constants, responseSelector, toTitleCase} from '../utils/utils';
import {useAlerts} from '../ui/alert';
import {alertTypes} from '../utils/Alert';
import {log} from '../utils/logs';
import {
  parametroEditDuck,
  parametroEditThunk,
  parametroGetDuck,
  parametroGetThunk,
} from './duck';
import {ParametroEditView} from './ParametroEditView';

export const ParametroEdit = ({history, match, token}) => {
  const id = match.params.id;

  const dispatch = useDispatch();

  const parametroGet = useSelector(state => state.parametroGet);
  const parametroEdit = useSelector(state => state.parametroEdit);

  const [concepto, setConcepto] = useState('');
  const [valor, setValor] = useState('');
  const [periodo, setPeriodo] = useState('');

  const [primeraEscala, setPrimeraEscala] = useState('');
  const [segundaEscala, setSegundaEscala] = useState('');
  const {topAlert, setTopAlert, submitAlert, setSubmitAlert} = useAlerts();

  useEffect(() => {
    const {data, httpStatus, error, errorMessage} =
      responseSelector(parametroGet);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(parametroGetDuck.actions.clear());
    }

    if (data) {
      console.log('ParametroEdit.data.periodo', data);

      dispatch(parametroGetDuck.actions.clear());

      setConcepto(toTitleCase(data?.concepto));
      setPeriodo(toTitleCase(data?.periodo));

      setValor(data?.valor);

      setPrimeraEscala(data?.escala?.[0]);
      setSegundaEscala(data?.escala?.[1]);
    }
  }, [parametroGet]);

  useEffect(() => {
    const {httpStatus, error, errorMessage} = responseSelector(parametroEdit);

    if (error) {
      setSubmitAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(parametroEditDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      history.goBack();

      dispatch(parametroEditDuck.actions.clear());
    }
  }, [parametroEdit]);

  useEffect(() => {
    dispatch(
      parametroGetThunk({
        id: id,
        userToken: token.raw,
      }),
    );
  }, []);

  const submit = () => {
    setTopAlert({
      text: '',
      type: alertTypes.danger,
      closable: false,
    });
    if (!valor || !primeraEscala || !segundaEscala) {
      setTopAlert({
        text: 'Por favor completar los campos obligatorios',
        type: alertTypes.danger,
        closable: false,
      });
    }
    let data = {
      id: id,
      userToken: token.raw,
      concepto,
      valor,
      escala: [primeraEscala, segundaEscala],
    };

    log({'submit.data': data});

    dispatch(parametroEditThunk(data));
  };

  return (
    <ParametroEditView
      history={history}
      parametroGet={parametroGet}
      parametroEdit={parametroEdit}
      submit={submit}
      submitAlert={submitAlert}
      topAlert={topAlert}
      concepto={concepto}
      setConcepto={setConcepto}
      valor={valor}
      setValor={setValor}
      primeraEscala={primeraEscala}
      setPrimeraEscala={setPrimeraEscala}
      segundaEscala={segundaEscala}
      setSegundaEscala={setSegundaEscala}
      periodo={periodo}
      setPeriodo={setPeriodo}
    />
  );
};
